import { useEffect, useState } from "react";
import Swal from "sweetalert2";

function AprobarAfiliados() {
  const [afiliados, setAfiliados] = useState([]);

  useEffect(() => {
    cargarPendientes();
  }, []);

  const cargarPendientes = async () => {
    try {
      const res = await fetch(
        "https://sindicato.sintrasecsalud.com/api/index.php?modulo=afiliacion&accion=afiliadosPendientes"
      );

      const data = await res.json();

      console.log("Respuesta afiliados pendientes:", data);

      if (!res.ok || !data.success) {
        console.error("Error API:", data);
        setAfiliados([]);
        return;
      }

      setAfiliados(
        Array.isArray(data.data)
          ? data.data
          : []
      );

    } catch (error) {
      console.error("Error cargando afiliados:", error);
      setAfiliados([]);
    }
  };

  const aprobar = async (id) => {
    try {
      const res = await fetch(
       
  `https://sindicato.sintrasecsalud.com/api/index.php?modulo=auth&accion=aprobarAfiliado&id=${id}`
);
      

      const data = await res.json();

      if (data.success) {
        Swal.fire(
          "Aprobado",
          "El afiliado fue aprobado y notificado por correo",
          "success"
        );

        cargarPendientes();
      } else {
        Swal.fire(
          "Error",
          data.error || data.message || "No se pudo aprobar el afiliado",
          "error"
        );
      }

    } catch (error) {
      console.error("Error aprobando afiliado:", error);

      Swal.fire(
        "Error",
        "No fue posible comunicarse con el servidor",
        "error"
      );
    }
  };

  return (
    <div className="container mt-5">
      <h4>Afiliados Pendientes de Aprobación</h4>

      <table className="table table-striped mt-3">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Cédula</th>
            <th>Email</th>
            <th>Acción</th>
          </tr>
        </thead>

        <tbody>
          {afiliados.length === 0 ? (
            <tr>
              <td colSpan="4" className="text-center">
                No hay afiliados pendientes de aprobación.
              </td>
            </tr>
          ) : (
            afiliados.map((a) => (
              <tr key={a.id}>
                <td>
                  {a.primerNombre} {a.primerApellido}
                </td>

                <td>
                  {a.numero_identificacion}
                </td>

                <td>
                  {a.email}
                </td>

                <td>
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => aprobar(a.id)}
                  >
                    Aprobar
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default AprobarAfiliados;